import { useMutation } from '@tanstack/react-query';

import { getApiClient } from '@cast/api-client';
import type { ReportingMonetizationTier } from '@cast/types';

import { getReportingMonetizationBaseUrl } from './reportingMonetizationBaseUrl';
import {
  notifyReportingMonetizationApiError,
  redirectToExternalUrl,
} from './reportingMonetizationRedirect';

export const useChangeReportingPlanMutation = () => {
  return useMutation({
    mutationFn: (tier: ReportingMonetizationTier) =>
      getApiClient().costReport.changeReportingMonetizationSubscriptionPlan({
        body: { tier, baseUrl: getReportingMonetizationBaseUrl() },
      }),
    onSuccess: (response) => {
      redirectToExternalUrl(
        response,
        'Plan change portal URL missing or invalid. Expected an absolute http(s) Stripe URL from the API.'
      );
    },
    onError: (error) => {
      notifyReportingMonetizationApiError(error, 'change plan');
    },
  });
};
